var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-state-color"},[_c('ColorPicker',{attrs:{"value":_vm._value},on:{"input":function($event){return _vm.$_onInput($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }